<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar color="accent" dark>
                            <v-icon class="mr-3">mdi-filter</v-icon>
                            <v-toolbar-title>Filter</v-toolbar-title>
                        </v-app-bar>
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3">
                              <v-select :items="data.financingType"
                                        chips small-chips deletable-chips
                                        label="Financing Type" solo />
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <v-select
                                            :items="data.schemeDropDownData"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Product"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <v-select
                                            :items="data.branch"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Branch"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <v-select
                                            :items="data.financingAmount"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Financing Amount Range"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <v-select
                                            :items="data.gfiStatus"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="GFI Status"
                                            solo

                                    />
                                </v-col>

                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <v-menu
                                            ref="startDateMenu"
                                            v-model="startDateMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="startDate"
                                            transition="scale-transition"
                                            min-width="290px"
                                            offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="startDate"
                                                    label="Start Date"
                                                    readonly
                                                    v-on="on"
                                                    solo

                                            />
                                        </template>
                                        <v-date-picker v-model="startDate" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="startDateMenu = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.startDateMenu.save(startDate)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <v-menu
                                            ref="endDateMenu"
                                            v-model="endDateMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="endDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="endDate"
                                                    label="End Date"
                                                    readonly
                                                    solo
                                                    v-on="on"
                                            />
                                        </template>
                                        <v-date-picker v-model="endDate" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="endDateMenu = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.endDateMenu.save(endDate)">OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="8" lg="3"
                                       class="d-flex justify-lg-end justify-sm-end justify-end justify-md-end mt-md-1 mt-lg-1">
                                    <v-btn >Reset</v-btn>
                                    <v-btn color="primary" class="ml-3" dark>Request</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar color="accent" dark>
                            <v-icon class="mr-3">mdi-file-excel</v-icon>
                            <v-toolbar-title>Data</v-toolbar-title>

                        </v-app-bar>
                        <v-row class="ml-3">
                <span :key="index" v-for="(headers, index) in headers">
                  <v-col v-if="headers.toggle">
                    <v-checkbox :label="headers.text" color="primary" v-model="headers.selectedCheckbox"/>
                  </v-col>
                </span>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-data-table
                                        :headers="filteredHeaders"
                                        :items="mockData"
                                        :items-per-page=10
                                        :footer-props="{
                                            'items-per-page-options': [10],
                                            'show-current-page':true
                                        }">

                                    <template v-slot:item.filter="{ item }">
                                        <v-icon @click="showInfoDialog(item.filter)">mdi-information-outline</v-icon>

                                    </template>
                                    <template v-slot:item.download="{ item }">
                                        <v-progress-circular
                                                v-if="item.download==='PROCESSING'"
                                                indeterminate
                                                :size="20"
                                                color="primary"
                                        ></v-progress-circular>
                                        <span v-else>
                                            <v-btn :href="'excel/user_result.xlsx'"  icon
                                                   text download>
                                                <v-icon color="green">mdi-file-download</v-icon>
                                            </v-btn>
                                        </span>

                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog max-width="450" persistent v-model="dialog">

                <v-card>
                    <v-card-title class="headline"
                    >Filters Applied
                    </v-card-title
                    >
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                <tr>
                                    <td width="200">Scheme</td>
                                    <td>:</td>
                                    <td>{{filter.scheme}}</td>
                                </tr>
                                <tr>
                                    <td>Branch</td>
                                    <td>:</td>
                                    <td>{{filter.branch}}</td>
                                </tr>
                                <tr>
                                    <td>Financing Amount Range</td>
                                    <td>:</td>
                                    <td>{{filter.financingAmountRange}}</td>
                                </tr>
                                <tr>
                                    <td>GFI Status</td>
                                    <td>:</td>
                                    <td>{{filter.gfiStatus}}</td>
                                </tr>
                                <tr>
                                    <td>Start Date</td>
                                    <td>:</td>
                                    <td>{{filter.startDate}}</td>
                                </tr>
                                <tr>
                                    <td>End Date</td>
                                    <td>:</td>
                                    <td>{{filter.endDate}}</td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn @click="dialog = false" color="green darken-1" text
                        >Close
                        </v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const data = require('../data/sample')
    export default {
        name: 'BulkDownload',
        data() {
            return {
                data: data,
                search: '',
                mockData: [
                    {
                        id: '1',
                        requestDate: '26/12/2019, 10.30am',
                        filter: {
                            scheme: 'BizMikro-i',
                            branch: 'Batu Pahat',
                            financingAmountRange: 'RM 7,501 – RM 9,000',
                            gfiStatus: 'PROCESSING',
                            startDate: '22/11/2019',
                            endDate: '22/12/2019'

                        },
                        download: 'PROCESSING',
                        status: 'Processing'
                    },
                    {
                        id: '2',
                        requestDate: '30/10/2019, 02.30pm',
                        filter: {
                            scheme: 'BizMikro-i',
                            branch: 'Ipoh',
                            financingAmountRange: 'RM 5,001 – RM 6,000',
                            gfiStatus: 'COMPLETED',
                            startDate: '24/09/2019',
                            endDate: '29/09/2019'

                        },
                        download: 'COMPLETED',
                        status: 'Completed'
                    },
                    {
                        id: '3',
                        requestDate: '04/12/2019 05.30pm',
                        filter: {
                            scheme: 'BizMikro-i',
                            branch: 'Kuala Terengganu',
                            financingAmountRange: 'more than RM 9,000',
                            gfiStatus: 'COMPLETED',
                            startDate: '22/10/2019',
                            endDate: '30/10/2010'

                        },
                        download: 'PROCESSING',
                        status: 'Processing'
                    }
                ],
                startDate: '',
                dialog: false,
                endDate: '',
                filter: {},
                startDateMenu: false,
                endDateMenu: false,
                headers: [
                    {
                        text: 'No. ',
                        align: 'left',
                        sortable: false,
                        value: 'id',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Request Date',
                        align: 'center',
                        sortable: true,
                        value: 'requestDate',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Filters Applied',
                        align: 'center',
                        sortable: false,
                        value: 'filter',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Status',
                        align: 'center',
                        sortable: false,
                        value: 'status',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Download',
                        align: 'center',
                        sortable: false,
                        value: 'download',
                        selectedCheckbox: true,
                        toggle: false
                    }
                ]

            }
        },
        methods: {
            showInfoDialog: function (data) {
                this.filter = data
                this.dialog = true
            }
        },
        computed: {
            filteredHeaders() {
                return this.headers.filter(h => h.selectedCheckbox)
            }
        }
    }
</script>

<style scoped>

</style>
